export const ignoredTraceTransactionPatterns = [
  /^Track Warmup$/,
  /^\/track_warmup_usage(?:\/|$)/,
  /^SteamCallback$/,
  /^\/steam\/callback(?:\/|$)/,
];

export const ignoredTraceRequestUrlPatterns = [
  /^https:\/\/ph\.refrag\.gg\//,
  /^https:\/\/(?:www\.)?google-analytics\.com\//,
  /^https:\/\/analytics\.google\.com\//,
  /^https:\/\/www\.google\.com\/(?:ads|ccm|pagead|rmkt)(?:\/|$)/,
  /^https:\/\/www\.googleadservices\.com\//,
  /^https:\/\/ad\.doubleclick\.net\//,
  /^https:\/\/stats\.g\.doubleclick\.net\//,
  /^https:\/\/pixel-config\.reddit\.com\//,
  /^https:\/\/aax(?:-[a-z]+)?\.amazon-adsystem\.com\//,
  /^https:\/\/ara\.paa-reporting-advertising\.amazon\//,
  /^https:\/\/c\.amazon-adsystem\.com\//,
  /^https:\/\/www\.facebook\.com\/tr(?:\/|$)/,
  /^https:\/\/connect\.facebook\.net\//,
  /^https:\/\/analytics\.tiktok\.com\//,
  /^https:\/\/(?:analytics|ads-api)\.twitter\.com\//,
  /^https:\/\/static\.ads-twitter\.com\//,
  /^https:\/\/bat\.bing\.com\//,
];

export const ignoredTraceSpanPatterns = ignoredTraceRequestUrlPatterns.map((pattern) => ({
  name: pattern,
  op: /^resource\..*/,
}));

export function shouldIgnoreTraceTransaction(name = '') {
  return ignoredTraceTransactionPatterns.some((pattern) => pattern.test(name));
}

export function shouldIgnoreTraceRequestUrl(url = '') {
  return ignoredTraceRequestUrlPatterns.some((pattern) => pattern.test(url));
}

export function shouldCreateTraceSpanForRequest(url) {
  return !shouldIgnoreTraceRequestUrl(url);
}

export function filterSentryTransaction(event) {
  return shouldIgnoreTraceTransaction(event.transaction) ? null : event;
}
